var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex items-center justify-center rounded-full bg-primary-600 text-sm text-white text-center",class:_setup.imgSize},[_vm._v("\n  "+_vm._s(_setup.letter)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }